import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActiveCartFacade, CART_NORMALIZER, Cart, PaymentType } from '@spartacus/cart/base/root';
import { CHECKOUT_PAYMENT_TYPE_NORMALIZER, CheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/core';
import { OccCheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/occ';
import {
  ConverterService,
  OccEndpointsService, UserIdService
} from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { CustomOcc } from '../../occ-models/custom-occ.models';

@Injectable()
export class CustomOccCheckoutPaymentTypeAdapter extends OccCheckoutPaymentTypeAdapter implements CheckoutPaymentTypeAdapter {
  cartId: string;
  userId: string;

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected activeCartService: ActiveCartFacade,
    protected userIdService: UserIdService,
    protected store: Store,
  ) {
    super(http, occEndpoints, converter);
  }

  getPaymentTypes(): Observable<PaymentType[]> {
    return combineLatest([this.userIdService.takeUserId(), this.activeCartService.getActiveCartId()]).pipe(
      take(1),
      switchMap(([userId, cartId]) => {
        return this.http
          .get<CustomOcc.PaymentTypeList>(this.occEndpoints.buildUrl('paymentModes', {
            urlParams: { cartId: cartId, userId: userId },
            queryParams: { fields: 'FULL' }
          }))
          .pipe(
            map((paymentTypeList) => {
                return paymentTypeList.paymentModes;
              }
            ),
            this.converter.pipeableMany(CHECKOUT_PAYMENT_TYPE_NORMALIZER)
          );
      }));
  }

  setPaymentType(
    userId: string,
    cartId: string,
    paymentType: string,
    purchaseOrderNumber?: string
  ): Observable<Cart> {

    const obj = { 'code': paymentType, 'fields': 'FULL' };
    if (purchaseOrderNumber !== undefined) {
      Object.assign(obj, { 'purchaseOrderNumber': purchaseOrderNumber });
    }

    const httpParams = new HttpParams({ fromObject: obj });
    const headers = new HttpHeaders();

    headers.set('Cache-Control', ['no-cache', 'no-store', 'max-age=0', 'must-revalidate']);
    headers.set('Accept', 'application/json');
    const url = this.occEndpoints.buildUrl(
      'setCartPaymentType',
      {
        urlParams: { cartId, userId },
        queryParams: obj
      })
    return this.http.put(url, null, { headers }).pipe(this.converter.pipeable(CART_NORMALIZER));
  }

  protected getCartEndpoint(userId: string): string {
    const cartEndpoint = 'users/' + userId + '/carts/';
    return this.occEndpoints.buildUrl(cartEndpoint);
  }
  creditCardList(userId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get(this.occEndpoints.buildUrl('creditCardList', { urlParams: { userId } }), { headers });
  }

  getSelectedCreditCard(userId: string, paymentDetailsId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get(this.occEndpoints.buildUrl('savedCreditCard', { urlParams: { userId, paymentDetailsId } }), { headers });
  }

  setSelectedCreditCard(userId: string, cartId: string, paymentDetailsId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.put(this.occEndpoints.buildUrl('updateSavedCreditCard', { urlParams: { userId, cartId, paymentDetailsId } }), { headers });
  }

  removeSelectedCreditCard(userId: string, paymentDetailsId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.delete(this.occEndpoints.buildUrl('savedCreditCard', { urlParams: { userId, paymentDetailsId } }), { headers });
  }
}
